import { INSTA_DEMOGRAPHICS } from '../constants/actionTypes';

const INITIAL_STATE = { data: [], errors: null };

export default function instaDemographicsData(state=INITIAL_STATE, action) {
  
  switch(action.type) {
    case INSTA_DEMOGRAPHICS:
    
      // const parsedData = JSON.parse(action.payload.data)

      return { ...state, data: action.payload.data, errors: null };
      
    default:
      return state;
  }
}